"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveShiftAttribute = void 0;
const store_1 = __importDefault(require("../store"));
const is_loading_1 = __importDefault(require("./is-loading"));
const shift_attribute_create_1 = __importDefault(require("../request/shift-attribute-create"));
const shift_attribute_update_1 = __importDefault(require("../request/shift-attribute-update"));
const load_workspace_detail_1 = __importDefault(require("@app/ac/load-workspace-detail"));
const create_ac_1 = require("./util/create-ac");
const util_1 = require("@app/util");
exports.saveShiftAttribute = (0, create_ac_1.createAC)(async (dispatch, { data, attributeId }) => {
    const { workspaceId } = store_1.default.getState();
    if (!(0, util_1.isValue)(workspaceId) || !(0, util_1.isValue)(data))
        return;
    dispatch((0, is_loading_1.default)('save-shift-attribute'));
    if ((0, util_1.isValue)(attributeId)) {
        // if 'attributeId' is set, we're modifying the existing attribute
        const result = await (0, shift_attribute_update_1.default)({
            workspace: workspaceId,
            ...data
        });
        await dispatch((0, load_workspace_detail_1.default)(workspaceId));
        dispatch((0, is_loading_1.default)('save-shift-attribute', true));
        return result;
    }
    else {
        // otherwise, we're just creating a new attribute
        const result = await (0, shift_attribute_create_1.default)({
            workspace: workspaceId,
            ...data
        });
        await dispatch((0, load_workspace_detail_1.default)(workspaceId));
        dispatch((0, is_loading_1.default)('save-shift-attribute', true));
        return result;
    }
});
exports.default = exports.saveShiftAttribute;
